/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { SVGProps } from 'react';

export const ListMessageIcon = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_20483_684"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.47656 8.72422C5.0008 8.72422 5.42578 8.29924 5.42578 7.775C5.42578 7.25076 5.0008 6.82578 4.47656 6.82578C3.95232 6.82578 3.52734 7.25076 3.52734 7.775C3.52734 8.29924 3.95232 8.72422 4.47656 8.72422ZM4.47656 5.68672C5.0008 5.68672 5.42578 5.26174 5.42578 4.7375C5.42578 4.21326 5.0008 3.78828 4.47656 3.78828C3.95232 3.78828 3.52734 4.21326 3.52734 4.7375C3.52734 5.26174 3.95232 5.68672 4.47656 5.68672ZM6.75469 7.01562H12.8297V8.53437H6.75469V7.01562ZM6.75469 3.97813H12.8297V5.49687H6.75469V3.97813ZM3.71719 15.3687V12.3313H2.19844C1.36009 12.3313 0.679688 11.6501 0.679688 10.8125V1.7C0.679688 0.86165 1.36009 0.18125 2.19844 0.18125H14.3484C15.1868 0.18125 15.8672 0.86165 15.8672 1.7V10.8125C15.8672 11.6501 15.1868 12.3313 14.3484 12.3313H7.76769L3.71719 15.3687ZM2.19844 1.7V10.8125H5.23594V12.3312L7.26043 10.8125H14.3484V1.7H2.19844Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_20483_684)">
      <rect x="-0.5" y="-1" width="18" height="18" fill="#202124" />
    </g>
  </svg>
);
